import React, { useState, useEffect } from "react";
import { DataView } from "primereact/dataview";
import { TabMenu } from "primereact/tabmenu";
import { Badge } from "primereact/badge";
import { BreadCrumb } from 'primereact/breadcrumb';
import { IPackage, requestGetPackages } from "./api";

import { getFormattedDate } from "shared/utils";
import { Link } from "react-router-dom";

import {
  SELLER_PACKAGE_STATES,
  SELLER_PACKAGE_STATES_LABELS,
} from "definitions";
import { ProgressSpinner } from "primereact/progressspinner";
import { Button } from "primereact/button";
import { getUrlToPostPackagePage } from "pages/urls";
import "./index.css";

const SELL_PACKAGE_URL = getUrlToPostPackagePage();

const items = [{ label: "All Packages", filters: [], icon: "pi pi-list" }];

export function ListPackagesPage() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [packagesList, setPackagesList] = useState<IPackage[]>([]);
  const [loadingPackages, setLoadingPackages] = useState(true);

  useEffect(() => {
    loadPackages();
  }, []);

  const loadPackages = async () => {
    const { packages } = await requestGetPackages();
    setLoadingPackages(false);
    setPackagesList(packages);
  };

  const itemTemplate = (data: IPackage, layout: string) => {
    return (
      <Link to={`/packages/${data._id}`} className="package-link">
        <div className="package-item col-12 flex my-2">
          <div className="col-12 flex text-left">
            <div className="col-4">
              <h4 className="package-item--name my-2">{data.name}</h4>
              <span className="package-item--date">
                {getFormattedDate(data.createdAt, "m,y")}
              </span>
            </div>
            <div className="col-8 package-item--info">
              <Badge
                value={SELLER_PACKAGE_STATES_LABELS[data.status]}
                severity={
                  [
                    SELLER_PACKAGE_STATES.PENDING_DROPOFF,
                    SELLER_PACKAGE_STATES.REVIEWED,
                  ].includes(data.status)
                    ? "warning"
                    : [
                        SELLER_PACKAGE_STATES.RECEIVED_AT_WAREHOUSE,
                        SELLER_PACKAGE_STATES.UNDER_REVIEW,
                        SELLER_PACKAGE_STATES.DROPPED_OFF,
                      ].includes(data.status)
                    ? "info"
                    : "success"
                }
              />
              <span className="package-item--status_message my-2">
                Will be received by Antidote once you drop off this package
              </span>
            </div>
          </div>
          <div className="col-12 flex align-items-center justify-content-between package-item--action">
            <div className="col-6 text-left"><span className="text-sm"><strong>Total Items</strong>: {data.totalItemsCount || "N/A"}</span></div>
            <Button className="p-button-text p-button-sm" label="VIEW" icon="pi pi-angle-right" iconPos="right" />
          </div>
        </div>
      </Link>
    );
  };

  return (
    <div
      style={{ maxWidth: "25rem" }}
      className="mx-auto w-full"
    >
      <div className="flex align-items-center">
        <div className="flex-grow-1">
          <BreadCrumb
            className="border-0"
            model={[{ label: "Packages" }]}
            home={{ icon: "pi pi-box" }}
          />
        </div>
        <div>
          <Link to={getUrlToPostPackagePage()} style={{ textDecoration: 'none' }}>
            <Button icon="pi pi-plus" className="p-button-rounded mr-2" />
          </Link>
        </div>
      </div>
      <div className="px-2 flex flex-column align-items-center">
        <TabMenu
          model={items}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="w-full"
        />
        <div className="w-full text-center">
          {loadingPackages ? (
            <>
              <ProgressSpinner strokeWidth="4" />
              <p>Loading...</p>
            </>
          ) : packagesList.length > 0 ? (
            <div>
              <DataView
                value={packagesList}
                layout="list"
                itemTemplate={itemTemplate}
              ></DataView>
            </div>
          ) : (
            <div>
              <h3 className="font-normal"> It is easy to start selling! </h3>
              <Link
                className="no-underline"
                to={SELL_PACKAGE_URL}
                referrerPolicy="same-origin"
              >
                <Button
                  icon="pi pi-shopping-cart"
                  label="Sell Your First Items"
                  className="p-button-sm"
                />
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
